import { cn } from '@/lib/utils.js';

// 8px circle. Accepts both vocabularies:
//   Command Center row urgency (services/command-center.service.js):
//     'urgent' → red · 'warn' → amber · 'info' → gray (NOT blue)
//   Pipeline-derived urgency (buildPipelineItem):
//     'CRITICAL' / 'EXPIRED' → red · 'URGENT' → amber
//     'NORMAL' → green · 'COMFORTABLE' → gray
//
// Urgency is FOUR levels only: red = NOW/past due; amber = today/this week;
// green = later >7d; gray = none. Blue is NOT an urgency — a tracking/FYI
// 'info' signal collapses to gray here rather than reusing the urgency dot
// (TRACON design system 2026-06-15; David's weak blue discrimination).

const URGENCY_COLOR = {
  urgent: 'bg-accent',
  CRITICAL: 'bg-accent',
  EXPIRED: 'bg-accent',
  warn: 'bg-warning',
  URGENT: 'bg-warning',
  info: 'bg-text-dim',
  NORMAL: 'bg-success',
  COMFORTABLE: 'bg-text-dim',
};

export default function UrgencyDot({ urgency, className }) {
  const color = URGENCY_COLOR[urgency] || 'bg-text-dim';
  return (
    <span
      aria-label={`urgency: ${(urgency || '').toLowerCase()}`}
      className={cn('inline-block h-2 w-2 shrink-0 rounded-full', color, className)}
    />
  );
}
